import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppLocalStorage } from 'app/app-storage-manager/local-storage';
import { MiscService } from 'app/shared/misc.service';
import { environment } from 'environments/environment';
import { map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class FeeSharingService {
    constructor(private http: HttpClient,  private miscService: MiscService) { }

    getFeeSharing = () => this.http.get(`${environment.API_URL}/fee-sharing/${this.miscService.getMerchantDetails().merchant_id}`)

    createFeeSharing = (payload) => this.http.post(`${environment.API_URL}/fee-sharing`, payload)

    updateFeeSharing = (payload, id) => this.http.put(`${environment.API_URL}/fee-sharing/${id}`, payload)

    deleteFeeSharing = (id) => this.http.delete(`${environment.API_URL}/fee-sharing/${id}`)
}